import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { parseISO } from "date-fns"
import { format } from "date-fns-tz"
import PageMetadata from "components/PageMetadata"
import AnimatedLogo from "components/AnimatedLogo"
import usePrefersReducedMotion from "hooks/usePrefersReducedMotion"
import structuredData from "structured-data/home.json"
import theme from "theme"

const Homepage = ({
  data: {
    page: { metadata, video },
  },
}) => {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <div>
      <PageMetadata {...metadata} structuredData={structuredData} />

      <div
        css={{
          ...theme.h1,
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 24,
          padding: 24,
          minHeight: 400,
          borderBottom: `2px solid ${theme.black}`,
          "@media (max-width: 1200px)": {
            gridTemplateColumns: "1fr",
          },
        }}
      >
        <h1 css={{ maxWidth: 600 }}>
          <AnimatedLogo
            css={{
              display: "inline-block",
              width: 196,
              position: "relative",
              top: "0.2em",
              [theme.tablet]: { width: 154 },
              [theme.mobile]: { width: 128 },
            }}
          />{" "}
          is a global design conference by Figma.
        </h1>
      </div>

      <video
        src={video?.asset?.url}
        css={{
          width: "100%",
          display: "block",
          maxHeight: "min(100vh, 800px)",
          objectFit: "cover",
        }}
        autoPlay={!prefersReducedMotion}
        muted
        loop
      />
    </div>
  )
}

export default Homepage

Homepage.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.shape({
      metadata: PropTypes.object.isRequired,
      video: PropTypes.shape({
        asset: PropTypes.shape({ url: PropTypes.string.isRequired }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}

const EventTimeRange = ({ startTime, endTime }) => (
  <span
    css={{ whiteSpace: "nowrap", [theme.mobile]: { whiteSpace: "normal" } }}
  >
    <time dateTime={startTime}>{format(parseISO(startTime), "haaa")}</time>–
    <time dateTime={endTime}>{format(parseISO(endTime), "haaa zzz")}</time>
  </span>
)

EventTimeRange.propTypes = {
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
}

export const query = graphql`
  {
    page: sanityConfigSettings {
      metadata: landingMetadata {
        ...Metadata
      }
      video: landingVideo {
        asset {
          url
        }
      }
    }
  }
`
